import { observable, toJS, extendObservable, computed, autorun} from 'mobx';
import {data} from './data.js';
import interact from 'interactjs';
import $ from 'jquery'

/** Converts numeric degrees to radians */
if (typeof(Number.prototype.toRad) === "undefined") {
  Number.prototype.toRad = function() {
    return this * Math.PI / 180;
  }
}        

// console.log("version 1.12");

export default class AppStore {

  constructor() {

    extendObservable(this, {

      loading: true,

      custom: false,

      group: null,
      group_current: computed(() => {
        return this.group;
      }),

      place_current_info: false,
      place_current_aside: null,
      place_current_stage: null,
      map_current: null,
      table_current: null,

      maps: [],
      places: [],
      places_current: computed(() => {

        var _places = [];
        var _tables = false;
        for (var i = 0; i < this.places.length; i++) {
          if (this.places[i].type !== 'tables'){
            _places.push(this.places[i]);
          }
        }
        return _places;
      }),
      items_current: computed(() => {

        var group = this.group;
        var items = group.items;
        var out = [];
        var extra = [];
        var map = this.map_current ? this.map_current.id : 0;

        for (var i = 0; i < items.length; i++) {
          var current = items[i];

          if(current.map === map){
            out.push(current);
          }

          else{

            if(current && current.group && current.group.type == 'tables'){
              let inMap = false;  
              let groupItems = current.group.items;

              for (let ii = 0; ii < groupItems.length; ii++) {
                if(groupItems[ii].map == map){
                  inMap = true;
                  break;
                }
              }

              if(inMap == true){
                extra.push(current);
              }

            }

            else{
              extra.push(current);
            }

          }

        }

        // add extra only if not path
        if(group && group.type && group.type != "path"){
          for (var i = 0; i < extra.length; i++) {

            var duplicate = false;
            var duplicateIndex1 = null;
            var duplicateIndex2 = null;

            for (var ii = 0; ii < out.length; ii++) {
              if(out[ii].name == extra[i].name){
                duplicate = true;
                duplicateIndex1 = i;
                duplicateIndex2 = ii;
                break;
              }
            }

            if(duplicate != true){
              out.push(extra[i]);
            }
            // overwrite if own map
            // else if(map === extra[duplicateIndex2].map){
            //   console.log("overwrite");
            //   out[duplicateIndex1] = extra[duplicateIndex2]; 
            // }

          }
        }

        // remove legends if not in map


        function compare(a,b) {
          if (a.name < b.name)
            return -1;
          if (a.name > b.name)
            return 1;
          return 0;
        }

        out.sort(compare);



// group: Object

// items: Array (3)
// 0 {type: "TEST_legenda_doppia", grouptype: "tables", map: 194, id: "194_TEST_legenda_doppia_0", name: "nome", …}
// 1 {type: "TEST_legenda_doppia", grouptype: "tables", map: 194, id: "194_TEST_legenda_doppia_1", name: "nome", …}
// 2 {type: "TEST_legenda_doppia", grouptype: "tables", map: 194, id: "194_TEST_legenda_doppia_2", name: "nome", …}

// Array Prototype

// name: "TEST legenda doppia"

// subtype: "TEST_legenda_doppia"

// type: "tables"




        return out;
      }),
      content_height: null,
      content_width: null,

      map_instance: null,
      map_transform_x: 0,
      map_transform_y: 0,
      map_animated: false,

      map_user_lat: null,
      map_user_lng: null,
      map_user_location: computed( ()=>{

        // console.log("changed",this.map_user_lat);

        // https://www.npmjs.com/package/haversine-position

        var map = this.map_current ? this.map_current : null;

        var out = {
          position: false,
          x: -10,
          y: -10
        };
        var offsetY = 0;
        var offsetX = 0;
        var offetRatio = 1;
        var factorX = 1;
        var factorY = 1; 
        var cohordinates = [];
        var distanceX = 0;
        var distanceY = 0;
        var user_lat = this.map_user_lat;
        var user_lng = this.map_user_lng;

        function getBearing(lon1, lat1, lon2, lat2) {

            var lat1 = Math.toRadians(lat1);
            var lat2 = Math.toRadians(lat2);
            var lon1 = Math.toRadians(lon1);
            var lon2 = Math.toRadians(lon2);

            var deltaLong = lon2 - lon1;

            var y = Math.sin(deltaLong) * Math.cos(lat2);
            var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1)
                    * Math.cos(lat2) * Math.cos(deltaLong);
            var bearing = Math.atan2(y, x);

            return (Math.toDegrees(bearing) + 360) % 360;
        }

        function getDistance(lon1, lat1, lon2, lat2) {
          var R = 6371; // Radius of the earth in km
          var dLat = (lat2-lat1).toRad();  // Javascript functions in radians
          var dLon = (lon2-lon1).toRad(); 
          var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) * 
                  Math.sin(dLon/2) * Math.sin(dLon/2); 
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
          var d = R * c; // Distance in km
          return d;
        }

        // keep 1 coordinate the same to get only x,y distance
        // function getDistanceX(lon1, lat1, lon1, lat2) {
        //   var R = 6371; // Radius of the earth in km
        //   var dLat = (lat2-lat1).toRad();  // Javascript functions in radians
        //   var dLon = (lon2-lon1).toRad(); 
        //   var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        //           Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) * 
        //           Math.sin(dLon/2) * Math.sin(dLon/2); 
        //   var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        //   var d = R * c; // Distance in km
        //   return d;
        // }
        // function getDistanceY(lon1, lat1, lon1, lat1) {
        //   var R = 6371; // Radius of the earth in km
        //   var dLat = (lat2-lat1).toRad();  // Javascript functions in radians
        //   var dLon = (lon2-lon1).toRad(); 
        //   var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        //           Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) * 
        //           Math.sin(dLon/2) * Math.sin(dLon/2); 
        //   var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
        //   var d = R * c; // Distance in km
        //   return d;
        // }


        // if(map){
        //   console.log("data",map,map.cohordinates,this.map_user_lat,this.map_user_lng,map.range_width,map.range_height);
        // }

        if(
            map && 
            map.cohordinates !== "" && 
            this.map_user_lat && 
            this.map_user_lng &&
            map.range_width &&
            map.range_height
          ){

          cohordinates = map.cohordinates.split(",");
          cohordinates[0] = parseFloat(cohordinates[0]);
          cohordinates[1] = parseFloat(cohordinates[1]);

          // distance in km
          // distance = getDistance(cohordinates[1], cohordinates[0], this.map_user_lng, this.map_user_lat);
          distanceX = getDistance(cohordinates[1], cohordinates[0], cohordinates[1], this.map_user_lat);
          distanceY = getDistance(cohordinates[1], cohordinates[0], this.map_user_lng, cohordinates[0]);
       
          // console.log("distance is",distanceX,distanceY);

          if(distanceX != 0 && distanceY != 0){

            // offset in m x = m/n*y;
            // offsetX = (cohordinates[0] - this.map_user_lat) / (cohordinates[1] - this.map_user_lng) * distance * 1000;
            // offsetY = (cohordinates[1] - this.map_user_lng) / ( cohordinates[0] - this.map_user_lat) * distance * 1000;

            // pixel size in km
            // factorX = map.range_width / map.width;
            // factorY = map.range_height / map.height;

            // offset in percentage; convert distance in meters
            offsetX = (distanceX*1000) / map.range_width * 100;
            offsetY = (distanceY*1000) / map.range_height * 100;

            // offset direction
            if(cohordinates[0] > this.map_user_lat){
              offsetX = offsetX * -1;
            }
            if(cohordinates[1] - this.map_user_lng){
              offsetY = offsetY * -1;
            }

          }

          out = {
            position: true,
            x: 50 + offsetX,
            y: 50 + offsetY
          }

        }

        return out;

      }),

      map_zoom: 1,

      map_scale: computed(() => {
        var scale = 1;
        var scaleWidth = 1;
        var scaleHeight = 1;
        if(this.map_current && this.map_current.height && this.content_height !== null){
          scaleHeight = this.content_height / this.map_current.height;
          scaleWidth = this.content_width / this.map_current.width;
          scale = (scaleHeight >= scaleWidth) ? scaleHeight : scaleWidth;
        }
        return scale;
      }),

      map_markers: computed(() => {
        var markers = [];
        if(this.place_current_stage !== null){
          // single
          if(this.place_current_stage.name){
            markers = [this.place_current_stage];
          }
          // multiple
          else{
            markers = this.place_current_stage;
          }
        }

        // meta case
        return markers;
      })

    });

    this.speed = 400;
    this.map_zoom_selected = 2.5;
    this.map_zoom_selectedDouble = 1.6;
    this.map_zoom_max = 2.5;
    this.map_zoom_min = 1;
    this.map_zoom_increment = 1.27;

    this.dataGet();

  }

  calculateDistance(){

  }

  dataGet(action){

    var store = this;

    $.ajax({
      url: window.ajaxurl + "?action=get_activities2",
      type: 'json',
      data:{
        mapid: window.mapid,
        action: 'get_activities2'
      },
      type: 'POST',
      success: function(_data){
          console.log(data);
        var data = JSON.parse(_data);
        store.mapSelect(data.maps[0]);
        store.maps = data.maps;
        store.places = data.places;
        store.loading = false;
        store.custom = data.custom;



        if(window.location.hash){
          var hash = window.location.hash;

          if(hash == "#dovemangiare"){
            store.places.map((place)=>{
              if(place.subtype == 'eat'){
                store.groupSelect(place);
              }
            });
          }

          else if(hash == "#dovedormire"){
            store.places.map((place)=>{
              if(place.subtype == 'hotel'){
                store.groupSelect(place);
              }
            });
          }
          else if(hash == "#shopping"){
            store.places.map((place)=>{
              if(place.subtype == 'shopping'){
                store.groupSelect(place);
              }
            });
          }
          else if(hash == "#tempolibero"){
            store.places.map((place)=>{
              if(place.subtype == 'sport'){
                store.groupSelect(place);
              }
            });
          }

        }

      },
      error: function(err){
        console.log(err);
      }
    });
  }

  contentSizeSet(height,width){
    this.content_height = height;
    this.content_width = width;
  }

  mapEventsInit(content,wrap){
    interact(wrap).gesturable({
    // onstart: function (event) {
    //   console.log("start",event.ds);
      // clearTimeout(resetTimeout);
      // scaleElement.classList.remove('reset');
    // },
    onmove: (event) => {

      var map_zoom_increment = 1 + event.ds;

      // zoom in case
      if(event.ds > 0){
        if(this.map_zoom < this.map_zoom_max){
          var scaleChange = ((this.map_zoom * map_zoom_increment) - this.map_zoom) * this.map_scale;
          // var offsetX = 0;
          // var offsetY = 0;
          // if(x && y){    
          //   // var Y = y - (this.map_current.height / 2);
          //   // var X = x - (this.map_current.width / 2);
          //   offsetX = -(X * scaleChange);
          //   offsetY = -(Y * scaleChange);
          // }
          this.map_animated = true;
          setTimeout(()=>{
            this.map_animated = false;
          },this.speed);
          this.map_zoom = this.map_zoom * map_zoom_increment;
          this.mapPanRelative(0,0,true);
        }
      }

      // zoom out case
      else{

        var mobileZoom = 1;

        if(this.map_zoom > mobileZoom){

          var zoom = this.map_zoom * map_zoom_increment;
          if(zoom <= mobileZoom){
            // this.mapZoomDefault();
          }
          else{

            this.map_animated = true;
            setTimeout(()=>{
              this.map_animated = false;
            },this.speed);  

            var offsetYMax = Math.abs(this.content_height - (this.map_current.height * this.map_scale * zoom)) / 2;
            var offsetXMax = Math.abs(this.content_width - (this.map_current.width * this.map_scale * zoom)) / 2;
            var offsetY = Math.abs(this.map_transform_y);
            var offsetX = Math.abs(this.map_transform_x);
            this.map_zoom = zoom;

            if(offsetY > offsetYMax){
              this.map_transform_y = this.map_transform_y >= 0 ? offsetYMax : (offsetYMax * -1);
            }
            if(offsetX > offsetXMax){
              this.map_transform_x = this.map_transform_x >= 0 ? offsetXMax : (offsetXMax * -1);;
            }

          }
        }

      }

    }
  }).draggable({
      inertia: true,
      onmove: (event) => {
        var target = event.target
        this.mapPanRelative(event.dx,event.dy,true);
      }
    });
    interact(wrap).on('doubletap',(e) =>{
      this.mapZoomIn(e.offsetX,e.offsetY)
    });
  }

  mapPanRelative(x,y,contrain){
    if(contrain === true){
      var offsetYMax = Math.abs(this.content_height - (this.map_current.height * this.map_scale * this.map_zoom)) / 2;
      var offsetXMax = Math.abs(this.content_width - (this.map_current.width * this.map_scale * this.map_zoom)) / 2;
      var offsetY = this.map_transform_y + y;
      var offsetX = this.map_transform_x + x;
      var offsetYAbs = Math.abs(offsetY);
      var offsetXAbs = Math.abs(offsetX);
      if( (offsetYAbs < offsetYMax) || (offsetY < 0 && y > 0) || (offsetY > 0 && y < 0) ){
        this.map_transform_y = this.map_transform_y + y;
      }
      if( (offsetXAbs < offsetXMax) ||  (offsetX < 0 && x > 0) || (offsetX > 0 && x < 0)  ){
        this.map_transform_x = this.map_transform_x + x;
      }

    }
    else{
      this.map_transform_y = this.map_transform_y + y;      
      this.map_transform_x = this.map_transform_x + x;
    }
  }

  mapSelect(map){
    // select map
    this.map_current = map;
    // set minimum zoom
    setTimeout(()=>{
      this.map_zoom = this.map_zoom_min;
      this.map_transform_x = 0;
      this.map_transform_y = 0;
    });
  }

  placeInfo(){
    this.place_current_info = true;
  }

  placeSelect(place,stageonly){

    var p = place;

    this.place_current_info = false;

    if(stageonly === true && place !== null){
      this.place_current_stage = place;
    }
    else{
      this.place_current_aside = place;
      this.place_current_stage = place;
    }

    if(place !== null) {

      if(place.map !== this.map_current.id){
        for (var i = 0; i < this.maps.length; i++) {
          if (this.maps[i].id === place.map) {
            this.map_current = this.maps[i];   
            break;
          }
        }
      }      

      if( place.grouptype === 'resource' || place.grouptype === 'path' ){

        this.map_animated = true;
        setTimeout(()=>{
          this.map_animated = false;
        },this.speed);

        // calculate offset based on map pixels
        // var mapZoom = this.map_zoom >= this.map_zoom_increment ? this.map_zoom : this.map_zoom_increment;
        var mapZoom = this.map_zoom_selected;
        // paths
        if(place.x2){
          mapZoom = this.map_zoom_selectedDouble;
        }
        var mapWidth = this.map_current.width;
        var mapHeight = this.map_current.height;
        var offsetX = ((place.x * -1)) + 50;
        var offsetY = ((place.y * -1)) + 50;
        var centerX = (this.map_current.width / 100 * offsetX) * (this.map_scale * mapZoom);
        var centerY = (this.map_current.height / 100 * offsetY) * (this.map_scale * mapZoom);

        // console.log("offset",place.x,place.y,offsetX,offsetY)
        // console.log("size map",this.map_current.width,this.map_current.height);
        // console.log("scale",this.map_scale);
        // console.log("zoom",mapZoom);
        // console.log("offset",centerX,centerY);

        this.map_transform_x = centerX;
        this.map_transform_y = centerY;
        this.map_zoom = mapZoom;

      }

      else if(place.grouptype === 'table'){
        // this.table_current = table;
        this.map_zoom = this.map_zoom_min;
        this.place_current_aside = place;        
      }

    }

    else{
      this.mapZoomDefault();
    }

  }

  placeMetaSelect(place){
    var p = toJS(place);
    this.place_current_stage = place;
    if(place !== null) {
      this.mapZoomDefault();
    }
  }

  groupSelect(group){
    this.group = group;
    // reset places
    this.place_current_stage = null;
    this.place_current_aside = null;
    // reset map position,zoom if group is closed
    if(group === null){
      this.mapZoomDefault();
    }
  }

  tableSelect(table){
    this.table_current = table;
    this.map_zoom = this.map_zoom_min;
    this.place_current_aside = table;
  }

  tableClose(){
    this.table_current = null;
  }

  mapZoomIn(x,y){
    if(this.map_zoom < this.map_zoom_max){
      var scaleChange = ((this.map_zoom * this.map_zoom_increment) - this.map_zoom) * this.map_scale;
      var offsetX = 0;
      var offsetY = 0;
      if(x && y){    
        var Y = y - (this.map_current.height / 2);
        var X = x - (this.map_current.width / 2);
        offsetX = -(X * scaleChange);
        offsetY = -(Y * scaleChange);
      }
      this.map_animated = true;
      setTimeout(()=>{
        this.map_animated = false;
      },this.speed);
      this.map_zoom = this.map_zoom * this.map_zoom_increment;
      this.mapPanRelative(offsetX,offsetY,true);
    }
  }
   
  mapZoomOut(){
    if(this.map_zoom > this.map_zoom_min){

      var zoom = this.map_zoom / this.map_zoom_increment;
      if(zoom <= 1){
        this.mapZoomDefault();
      }
      else{

        this.map_animated = true;
        setTimeout(()=>{
          this.map_animated = false;
        },this.speed);  

        var offsetYMax = Math.abs(this.content_height - (this.map_current.height * this.map_scale * zoom)) / 2;
        var offsetXMax = Math.abs(this.content_width - (this.map_current.width * this.map_scale * zoom)) / 2;
        var offsetY = Math.abs(this.map_transform_y);
        var offsetX = Math.abs(this.map_transform_x);
        this.map_zoom = zoom;

        if(offsetY > offsetYMax){
          this.map_transform_y = this.map_transform_y >= 0 ? offsetYMax : (offsetYMax * -1);
        }
        if(offsetX > offsetXMax){
          this.map_transform_x = this.map_transform_x >= 0 ? offsetXMax : (offsetXMax * -1);;
        }

      }
    }
  }

  mapZoomDefault(){
    this.map_animated = true;
    this.map_zoom = this.map_zoom_min;
    this.map_transform_y = 0;
    this.map_transform_x = 0; 
    setTimeout(()=>{
      this.map_animated = false;
    },this.speed);  
  }

}





// WEBPACK FOOTER //
// ./src/store.js